<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import CommonInput from "~/components/Common/Inputs/CommonInput.vue";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const emit = defineEmits(["closeModal", "update:modelValue", "removeLink", "saveLink"]);

function hideModal() {
  emit("closeModal");
}

function saveLink() {
  emit("saveLink");
  hideModal();
}

const props = defineProps({
  modelValue: {
    type: String,
  },
});

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <div class="z-[10000]">
    <CenterModal style="width: 420px" @hide="hideModal">
      <template #body>
        <div class="p-[24px]">
          <h3 class="heading_3_med text-primary-color pb-[12px]">Saisissez un lien ci-dessous</h3>
          <CommonInput
            v-model="value"
            :nullable="true"
            type="text"
            placeholder="Ajouter une URL"
            style="text-align: start"
          ></CommonInput>
          <div class="flex gap-[18px] justify-end gap pt-[16px]">
            <AppButton type="outlined" label="Annuler" @click="hideModal" />
            <AppButton label="Ajouter" @click="saveLink" />
          </div>
        </div>
      </template>
    </CenterModal>
  </div>
</template>

<style scoped></style>
